<template>
  <div>
    <v-card flat color="transparent" class="mt-7">
      <v-toolbar class="bdr secondary2light" :elevation="0" outlined>
        <v-toolbar-title
          class="grey--text text--darken-2"
          style="font-size: 18px"
          >{{ $t("animal.activity") }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>

    <v-card flat class="mt-7">
      <v-card-text>
        <v-toolbar flat width="100%">
          <v-toolbar-title class="text-capitalize title"
            >{{ $t("animal.report.activity") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-btn
            right
            class="ml-5"
            height="50"
            width="241"
            color="primary"
            type="submit"
            @click="$router.push({ name: 'CreateTask', params: { animalId } })"
          >
            {{ $t("animal.activityRecord.createNewActivity") }}
          </v-btn>
        </v-toolbar>

        <v-data-table
          :headers="this.tableHeaders"
          :items="activities"
          :items-per-page="10"
          hide-default-footer
          :loading="loading"
          :options.sync="tableOptions"
          :server-items-length="activities && activities.totalCount"
          show-select
          :search="search"
          loading-text="Loading Data..."
        >
          <template v-slot:top>
            <div class="d-flex mt-5">
              <v-text-field
                prepend-inner-icon="mdi-magnify"
                outlined
                height="5px"
                placeholder="Search"
                dense
                v-model="search"
                class="shrink"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <div class="py-3">{{ from }} of {{ totalPages }}</div>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                :disabled="tableOptions.page <= 1"
                @click="pageChange(false)"
              >
                <v-icon dark> mdi-chevron-left </v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                :disabled="tableOptions.page >= totalPages"
                @click="pageChange(true)"
              >
                <v-icon dark> mdi-chevron-right </v-icon>
              </v-btn>
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-width="200"
                left
                :min-width="417"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark> mdi-cog-outline</v-icon>
                  </v-btn>
                </template>
                <v-card width="417">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          $t("farm.customization")
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <div class="pl-3 pt-2 font-weight-normal">
                      {{ $t("farm.recordsPerpage") }}
                    </div>
                    <v-list-item>
                      <v-list-item-content>
                        <v-slider
                          v-model="itemsPerPageSlider"
                          :tick-labels="itemsPerPageOptions"
                          :max="3"
                          step="1"
                          ticks="always"
                          tick-size="4"
                        ></v-slider>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-n3"></v-divider>
                  </v-list>
                  <v-card-text>
                    <v-row>
                      <v-col
                        class="mt-n9"
                        cols="6"
                        v-for="header in headers"
                        :key="header.value"
                      >
                        <v-checkbox
                          v-if="header.value !== 'action'"
                          v-model="selectedHeaders"
                          :label="header.text"
                          color="primary"
                          :value="header.text"
                          hide-details
                          :disabled="
                            header.text == 'ID' || header.text == 'Tag'
                          "
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-layout justify-center>
                    <v-card-actions class="mb-5">
                      <v-spacer></v-spacer>
                      <v-btn
                        outlined
                        color="primary"
                        @click="resetDefault"
                        width="fit-content"
                      >
                        {{ $t("farm.restoreDefault") }}
                      </v-btn>
                      <v-btn
                        color="primary"
                        @click="resetTableStructure"
                        width="190"
                      >
                        {{ $t("farm.apply") }}
                      </v-btn>
                    </v-card-actions>
                  </v-layout>
                </v-card>
              </v-menu>
            </div>
          </template>

          <template v-slot:item.status="{ item }">
            <!-- <div style="
                display: flex;
                width: 120px;
                color: green;
                background: #e5f8f1;
                padding: 8px;
                border-radius: 50px;
                justify-content: center;
                border: 1px solid green;
                font-size: 13px;
              " class="text-center" v-if="item.newStatus == 'Canceled'">
              {{ item.newStatus }}
            </div> -->
            <div
              style="
                display: flex;
                width: 120px;
                color: green;
                background: #e5f8f1;
                padding: 8px;
                border-radius: 50px;
                justify-content: center;
                border: 1px solid green;
                font-size: 13px;
              "
              class="text-center"
              v-if="item.newStatus == 'Completed'"
            >
              {{ item.newStatus }}
            </div>

            <div
              style="
                display: flex;
                width: 120px;
                color: #000000;
                background: #e8e8e8;
                padding: 8px;
                border-radius: 50px;
                justify-content: center;
                border: 1px solid #000000;
                font-size: 13px;
              "
              class="text-center"
              v-if="item.newStatus == 'To-Do'"
            >
              {{ item.newStatus }}
            </div>

            <div
              style="
                display: flex;
                width: 120px;
                color: #ffb443;
                background: #fff0d9;
                padding: 8px;
                border-radius: 50px;
                justify-content: center;
                border: 1px solid #ffb443;
                font-size: 13px;
              "
              class="text-center"
              v-if="item.newStatus == 'Pending'"
            >
              {{ item.newStatus }}
            </div>
          </template>

          <template v-slot:item.startDate="{ item }">
            <div>
              {{ formatDate(item.startDate) }}
            </div>
          </template>

          <template v-slot:item.action="{ item }">
            <v-toolbar flat width="100%">
              <v-icon dark color="gray" @click="startDelete(item, 'edit')">
                mdi-pencil
              </v-icon>
              <v-icon dark color="red" @click="startDelete(item, 'delete')">
                mdi-delete
              </v-icon>
            </v-toolbar>
          </template>
          <template v-slot:footer></template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="showDeleteConfirm"
      transition="dialog-top-transition"
      max-width="500"
      persistent
    >
      <template>
        <v-card rounded="0">
          <v-toolbar color="secondary" class="white--text">
            <v-toolbar-title class="font-weight-bold">
              Warning
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              class="white--text"
              @click="
                showDeleteConfirm = false;
                deleteItem = null;
              "
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="gray--text py-10" style="font-size: 16px">
            <h2>Are you sure ?</h2>
            <p class="mt-4">Do you really want to delete this record ?</p>
            <p>This process cannot be undone.</p>
            <!--<p>Your previous records might get affected.</p>-->
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="px-4 py-5 justify-center">
            <div>
              <v-spacer></v-spacer>
              <v-btn
                @click="
                  showDeleteConfirm = false;
                  deleteItem = null;
                "
                outlined
                class="mr-2 px-5"
                right
                height="44"
                depressed
                color="primary"
              >
                {{ $t("cancel") }}
              </v-btn>
              <v-btn
                @click="deleteDisease"
                right
                height="44"
                color="error"
                class="px-5"
              >
                Delete
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <AddReport
      @dialog:close="showAddReport = false"
      @report:added="onReportAdded"
      :dialogI="showAddReport"
      v-if="showAddReport"
    />
  </div>
</template>

<script>
import gql from "graphql-tag";

import AddReport from "./AddReport.vue";
import moment from "moment";
import loadingMixin from "@/mixins/LoadingMixin";

export default {
  apollo: {
    conceptionData: {
      query: gql`
        query reports($animalId: Int!) {
          reports(animalId: $animalId) {
            activity
            date
            status
          }
        }
      `,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      update: data =>
        data.reports.map(item => ({
          ...item,
          date: moment(Number(item.date)).format("YYYY-MM-DD"),
        })),
    },
    activities: {
      query: gql`
        query activityOfAnimal($animalId: Int!) {
          activityOfAnimal(animalId: $animalId) {
            totalCount
            count
            rows {
              startDate
              endDate
              taskCategoryId
              taskCategory {
                id
                name
              }
              status
              newStatus
              id
              title
            }
          }
        }
      `,
      fetchPolicy: "no-cache",
      variables() {
        console.log(this.search, "this.searchthis.search");
        return {
          page: this.tableOptions.page,
          limit: this.tableOptions.itemsPerPage,
          search: this.search,
          animalId: parseInt(this.$route.params.animal_number),
        };

        // return {

        //   animalId: parseInt(this.$route.params.animal_number),
        // }
      },
      result({ data }) {
        // console.log(data)
        this.totalActivity = data.activityOfAnimal.totalCount;
        this.totalPages = Math.ceil(
          this.totalActivity / this.tableOptions.itemsPerPage
        );

        this.from = this.tableOptions.page;
        this.to = this.totalPages;
        // this.from = (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
        // this.to =
        //   this.tableOptions.page * this.tableOptions.itemsPerPage -
        //   (this.tableOptions.itemsPerPage - data.activityOfAnimal.count);
      },
      update: data => data.activityOfAnimal.rows,
    },
  },
  components: {
    AddReport,
  },

  watch: {
    tableOptions: {
      handler() {},
      deep: true,
    },
    search() {
      console.log("asdasd");

      (this.tableOptions = {
        itemsPerPage: 10,
        page: 1,
      }),
        this.$apollo.queries.activities.refetch();
    },
  },

  data() {
    return {
      menu: false,
      tableHeaders: [],
      from: 0,
      to: 0,
      tableOptions: {
        itemsPerPage: 10,
        page: 1,
      },
      totalActivity: "",
      totalPages: "",
      search: "",

      showDeleteConfirm: false,
      deleteItem: null,
      loading: false,
      showAddReport: false,
      allSelectedHeaders: ["Activity", "Date", "Status"],
      headers: [
        {
          text: this.$t("activity"),
          align: "start",
          sortable: true,
          value: "title",
        },
        {
          text: this.$t("date"),
          align: "start",
          sortable: true,
          value: "startDate",
        },
        { text: this.$t("status"), value: "status", sortable: true },
        { text: "", value: "action" },
      ],
      itemsPerPageSlider: 0,
      itemsPerPageOptions: [5, 10, 25, 50],
      selectedHeaders: [],
      animalId: null,
    };
  },
  methods: {
    resetTableStructure() {
      this.startLoading();
      this.tableHeaders = this.headers.filter(header =>
        this.selectedHeaders.includes(header.text.toString())
      );

      this.tableOptions.itemsPerPage =
        this.itemsPerPageOptions[this.itemsPerPageSlider];
      this.menu = false;
      this.stopLoading();
    },

    resetDefault() {
      this.tableHeaders = this.headers;
      this.selectedHeaders = this.allSelectedHeaders;
      this.menu = false;
    },
    pageChange(t) {
      if (t) {
        this.tableOptions.page = this.tableOptions.page + 1;
        return;
      } else {
        this.tableOptions.page = this.tableOptions.page - 1;
        return;
      }
    },
    async deleteDisease() {
      if (!this.deleteItem) {
        alert("No activity to delete");
        return;
      }

      // let item = this.deleteItem;
      // //this.startLoading();
      // this.$apollo
      //   .mutate({
      //     // Query
      //     mutation: gql`
      //       mutation ($diseaseId: Int!) {
      //         removeAnimalDisease(diseaseId: $diseaseId) {
      //           success
      //         }
      //       }
      //     `,
      //     // Parameters
      //     variables: {
      //       diseaseId: Number(item.id),
      //     },
      //   })
      //   .then(async (response) => {
      //     this.$notify({
      //       title: `History deleted successfully`,
      //       text: response.message,
      //       type: "success",
      //       position: "top right",
      //     });

      //     this.showDeleteConfirm = false;
      //     this.deleteItem = null;
      //     this.$apollo.queries.animalDiseases.refetch();
      //     //this.stopLoading();
      //   })
      //   .catch(async (error) => {
      //     console.log(error);
      //     this.showDeleteConfirm = false;
      //     this.deleteItem = null;
      //     //this.stopLoading();
      //   });
      // console.log("delete disease");
    },
    async startDelete(item, action) {
      if (action == "edit") {
        this.$router.push({ name: "UpdateTask", params: { task_id: item.id } });
      } else {
        this.showDeleteConfirm = true;
        this.deleteItem = item;
      }

      //this.$apollo.queries.birthOriginByFarmId.skip = false;
      //let res = await this.$apollo.queries.birthOriginByFarmId.refetch();
      //this.noOfAnimalsInFarm = res.data.birthOriginByFarmId
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    onReportAdded() {
      this.$apollo.queries.conceptionData.refetch();
    },
  },

  mounted() {
    this.tableHeaders = this.headers;
    this.selectedHeaders = this.allSelectedHeaders;
    this.animalId = parseInt(this.$route.params.animal_number);
  },
  mixins: [loadingMixin],
};
</script>
<style lang="scss" scoped>
::v-deep .v-data-table-header {
  background: $secondary2-color;
  border-radius: 5px 5px;
}

::v-deep .v-data-table-header span {
  // text-transform: uppercase !important;
  color: black;
}

::v-deep .primary2bg {
  background-color: $green2 !important;
}
</style>
